var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5 10L3.58579 8.58579L8.29289 3.87868L13 8.58579L11.5858 10L8.29289 6.70711L5 10Z",
      "fill": "black"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }